import { environment } from 'src/environments/environment';
import { Component, OnInit, AfterViewInit, ViewChild, ElementRef } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import { SEO } from '~project/shared/services/SEO/service';
//[PrimeNG]
import { MessageService } from 'primeng/api';
// [[Providers]]
import { CustomerUserService } from 'src/project/services/panel/client/marketplace/customer/user/user.service';
import { CollectiveMarketplaceService } from '~services/collective/client/marketplace/marketplace.service';
import { CollectiveMarketplaceCartService } from '~services/collective/client/marketplace/cart/cart.service';
import { CollectiveMarketplaceCoreVisualBannerService } from '~services/collective/client/marketplace/core/visual/banner/banner.service';
// [[Providers: Component]]
import { CollectiveMarketplaceCoreSubscriptionKitService } from '~services/collective/client/marketplace/core/subscription/kit/subscription-kit.service';
import { CollectiveMarketplaceCartSubscriptionKitService } from '~services/collective/client/marketplace/cart/cart-subscription-kit.service';
// ]
// [[Interfaces/Models do Componente]]
import { Meta } from '~components/pagination/interfaces/pagination';
// ]
// [[Functions]]

// ]
@Component({
  selector: 'app',
  templateUrl: './component.html',
  styleUrls: ['./component.scss'],
})
export class SubscriptionKitViewComponent implements OnInit {
  /**
   * Base de uso em Component
   */
  public environment = environment;
  messageProcess = false;
  messageIsError: any;
  profile: any;
  marketplace: any = null;
  cart: any = null;
  banners: any = null;
  banners_fnc_cta: any = null;

  constructor(
    /**
     * Serviços da Aplicação
     */
    private titleService: Title,
    private activatedRoute: ActivatedRoute,
    private router: Router,

    /**
     * Base de uso em Component
     */
    private userService: CustomerUserService,
    private collectiveMarketplaceService: CollectiveMarketplaceService,
    private collectiveMarketplaceCartService: CollectiveMarketplaceCartService,
    private collectiveMarketplaceCoreVisualBannerService: CollectiveMarketplaceCoreVisualBannerService,
    private pageSEO: SEO,
    /**
     * PrimeNg
     */
    private messageService: MessageService,
    /**
     * Services
     */
    private collectiveMarketplaceCoreSubscriptionKitService: CollectiveMarketplaceCoreSubscriptionKitService,
    private collectiveMarketplaceCartSubscriptionKitService: CollectiveMarketplaceCartSubscriptionKitService
  ) {}

  /**
   * on init
   */
  ngOnInit() {
    this.ipBuildEcommerceDependencies();
    this.router.events.subscribe((ev) => {
      if (ev instanceof NavigationEnd) {
        this.ngAfterViewInit();
      }
    });
  }

  /**
   * build ecommerce dependencies
   */
  ipBuildEcommerceDependencies() {
    /**
     * Base
     *
     * Request da base de uso.
     */
    // PROFILE
    this.userService.getUser().subscribe((Profile: any) => {
      if (Profile != null) {
        if (JSON.parse(Profile) != null) {
          this.profile = JSON.parse(Profile);
        }
      }
    });
    // MARKETPLACE
    this.collectiveMarketplaceService.getMarketplace().subscribe((Marketplace: any) => {
      if (Marketplace != null) {
        if (JSON.parse(Marketplace) != null) {
          this.marketplace = JSON.parse(Marketplace);
          /**
           *
           * CONFIGURAÇÕES ADICIONAIS DESTE `COMPONENTE`
           *
           */
          // SEO
          this.titleService.setTitle(this.marketplace.name);
        }
      }
    });
    // CART
    this.collectiveMarketplaceCartService.getCart().subscribe((Cart: any) => {
      if (Cart != null) {
        if (JSON.parse(Cart) != null) {
          this.cart = JSON.parse(Cart);
        }
      }
    });
    // BANNERS
    this.banners_fnc_cta = function (banner: any) {
      if (banner.url != '') {
        document.location = banner.url;
      }
      return false;
    };
    this.collectiveMarketplaceCoreVisualBannerService.getBanners().subscribe((Data: any) => {
      if (Data != null) {
        if (JSON.parse(Data) != null) {
          this.banners = JSON.parse(Data);
        }
      }
    });
  }

  /**
   * after view init
   */
  ngAfterViewInit() {
    /* This is a function that sets the title of the page. */
    this.pageSEO.setTitle({ title: 'CLUBE Gê' });

    this.collectiveMarketplaceCoreSubscriptionKitServiceShow();
  }

  /**
   * on destroy
   */
  ngOnDestroy() {}

  kit: any;
  /**
   * Collectives marketplace core subscription kit service show
   */
  collectiveMarketplaceCoreSubscriptionKitServiceShow(): void {
    this.activatedRoute.params.subscribe((params) => {
      const id = +params['id'];
      const _ = this.collectiveMarketplaceCoreSubscriptionKitService.view({ id: id });
      if (_ !== null) {
        _.subscribe(
          (response: any) => {
            this.kit = response.data;
          },
          (error) => {
            this.collectiveMarketplaceCoreSubscriptionKitService.error.throw(error);
          }
        );
      }
    });
  }

  /**
   * Collectives marketplace cart subscription kit service create
   */
  collectiveMarketplaceCartSubscriptionKitServiceCreate() {
    let _ = this.collectiveMarketplaceCartSubscriptionKitService.create_new_cart_using_kit_products({ core_subscription_kit_id: this.kit.id });
    if (_ !== null) {
      _.subscribe(
        (response: any) => {
          document.location.href = '/p/cart?uid=' + response.data.client_marketplace_cart_uid;
        },
        (err) => {
          this.messageProcess = false;
          if (err.error.errors) {
            for (let error in err.error.errors) {
              this.messageService.add({ severity: 'error', detail: err.error.errors[error] });
              this.messageProcess = false;
              this.messageIsError = this.collectiveMarketplaceCartSubscriptionKitService.error.throw(error);
            }
          }
        }
      );
    }
  }
}
